

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Header } from "../../../domain/system/table";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import { ModelEditableMixin } from "../../system/mixins";
import HisItemComponent from "../components/HisItemComponent.vue";

@Component({
  components: {
    HisItemComponent,
  },
})
/** HIS選択画面のテーブルの列幅を文字列に合わせるため、その列幅を取得するためのテーブル */
export default class HisInfoColumnWidthTable extends Mixins(ModelEditableMixin) {
  @Prop()
  headers: Header[];
  @Prop()
  options: HisInformationListItem[];
  @Prop()
  dateFormat: string;

  editingSource: number[];

  $refs!: {
    tableHeader: HTMLTableRowElement;
  };

  updateColumnWidths(): void {
    const columns = this.cellsToArray(this.$refs.tableHeader.cells);
    this.editingSource = columns.map(x => x.offsetWidth);
  }

  private cellsToArray(cs: HTMLCollection): any[] {
    const arr = [] as any[];
    for (let i = 0; i < cs.length; i++) {
      const c = cs.item(i);
      arr.push(c);
    }
    return arr;
  }
}
